// extracted by mini-css-extract-plugin
module.exports = {"module":"ContextMenuTrigger_module__2OaxF","uActive":"ContextMenuTrigger_uActive__1l6Ko","uInactive":"ContextMenuTrigger_uInactive__cTo7-"};